// Extracts the displayable message from the customer API error contract.
// The BACKEND owns all copy (every form constraint carries a friendly
// `message:`; HttpExceptions carry an authored message), so this only reads
// it — no client-side rewriting, no status→text maps.
//
// The API emits exactly two shapes (see api Subscriber\Exception):
//   validation     → { details: { field: ["message", …] } }
//   everything else → { errors: { detail: "message" } }
export function extractErrorMessage(payload) {
    const body = payload?.response;
    if (!body || typeof body !== 'object') {
        return typeof payload === 'string' ? payload : null;
    }

    // Field validation — join the per-field messages on one line.
    if (body.details && typeof body.details === 'object') {
        const messages = Object.values(body.details).flat().filter(Boolean);
        if (messages.length) return messages.join(' ');
    }

    return body.errors?.detail || 'Something went wrong. Please try again.';
}
